var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.33333H11.6667M2 6.26667C2 4.77333 2 4.02667 2.29067 3.456C2.54633 2.95426 2.95426 2.54633 3.456 2.29067C4.02667 2 4.77333 2 6.26667 2H9.73333C11.2267 2 11.9733 2 12.544 2.29067C13.0457 2.54633 13.4537 2.95426 13.7093 3.456C14 4.02667 14 4.77333 14 6.26667V9.73333C14 11.2267 14 11.9733 13.7093 12.544C13.4537 13.0457 13.0457 13.4537 12.544 13.7093C11.9733 14 11.2267 14 9.73333 14H6.26667C4.77333 14 4.02667 14 3.456 13.7093C2.95426 13.4537 2.54633 13.0457 2.29067 12.544C2 11.9733 2 11.2267 2 9.73333V6.26667Z",
    stroke: "#FFD60A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.265 8.56744C10.3395 8.27019 10.3548 7.96118 10.3098 7.65804C10.2191 7.04584 9.88895 6.49473 9.39192 6.12598C8.89488 5.75722 8.27172 5.60101 7.65951 5.69171C7.0473 5.78242 6.4962 6.1126 6.12744 6.60964C5.75868 7.10667 5.60247 7.72984 5.69318 8.34204C5.78388 8.95425 6.11407 9.50535 6.6111 9.87411C6.85721 10.0567 7.13687 10.189 7.43412 10.2635C7.73136 10.3381 8.04037 10.3533 8.34351 10.3084C8.64664 10.2635 8.93796 10.1593 9.20084 10.0018C9.46371 9.84429 9.69299 9.63656 9.87558 9.39045C10.0582 9.14435 10.1905 8.86469 10.265 8.56744Z",
    stroke: "#FFD60A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram2);
export default __webpack_public_path__ + "static/media/instagram2.16066f8667a0e2b4c082054006a2181c.svg";
export { ForwardRef as ReactComponent };